import RE from "../assets/replace.js";

let module;

async function loadScriptBasedOnPid() {
    try {
        switch (RE.pid) {
            case 'tt':
                if (RE.isPost) {
                    module = await import('./tts.js');
                } else {
                    module = await import('./tt.js');
                }
                break;
            case 'fb':
                module = await import('./fb.js');
                break;
            case 'gg':
                module = await import('./gg.js');
                break;
            // case 'x':
            //     if (RE.language == 'EN') {
            //         module = await import('./x-EN.js');
            //     } else {
            //         module = await import('./x.js');
            //     }
            //     break;
            // case 'L':
            //     module = await import('./l.js');
            //     break;
            case null:
                break;
            default:
                console.error('Unknown pid:', RE.pid);
                return;
        }
    } catch (error) {
        console.error('Error loading script:', error);
    }
}

loadScriptBasedOnPid();

export const Channel = {
    track: function (event, data) {
        if(RE.pid == 'tt'){
            ttq.track('ClickButton', RE);
        }
        if(RE.pid == 'fb'){
            module.FACE_TGA();
        }
        if(RE.pid == 'gg'){
            if(RE.os == 0){
                module.gtag_report_conversion_and();
            } else {
                module.gtag_report_conversion_ios();
            }
        }
        // if(RE.pid == 'x'){
        //     if (RE.language == 'EN') {
        //         twq('event', 'tw-opiri-opis3', {
        //             conversion_id: localStorage.getItem('capybarago_uuid') // 使用唯一 ID 进行去重
        //         });
        //     } else {
        //         twq('event', 'tw-onxvv-ony8x', {
        //             conversion_id: localStorage.getItem('capybarago_uuid') // 使用唯一 ID 进行去重
        //         });
        //     }
        // }
        // if(RE.pid == 'L'){
        //     console.log('Line Tag');
        //     module.sendConversion();
        // }
    }
};


// WEBPACK FOOTER //
// ./src/utils/channel.js